import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { NAVBAR_HEIGHT } from '@constants';
import useDesktop from '../useDesktop';

interface TwoColumnScrollSyncProps {
  leftColumnContent: React.ReactNode;
  rightColumnContent: React.ReactNode;
}

const TwoColumnScrollSync: React.FC<TwoColumnScrollSyncProps> = ({ leftColumnContent, rightColumnContent }) => {
  const leftColumnRef = useRef<HTMLDivElement>(null);
  const rightColumnRef = useRef<HTMLDivElement>(null);
  const isDesktop = useDesktop(1024);

  useEffect(() => {
    const handleScroll = () => {
      if (!leftColumnRef.current || !rightColumnRef.current) return;
      const leftColumnChild = leftColumnRef.current?.children[0] as HTMLDivElement;
      if (!leftColumnChild) return;
      const { top: rightTop, bottom: rightBottom } = rightColumnRef.current.getBoundingClientRect();
      const isLeftChildBellowBottom = leftColumnChild.offsetHeight > rightBottom - NAVBAR_HEIGHT;

      if (isLeftChildBellowBottom && isDesktop) {
        // Move to bottom
        leftColumnChild.style.position = 'absolute';
        leftColumnChild.style.top = 'auto';
        leftColumnChild.style.bottom = '0';
        leftColumnChild.style.width = '50%';
      } else if (rightTop < NAVBAR_HEIGHT && isDesktop) {
        const oldWidth = leftColumnChild.offsetHeight;

        // Stick to nav bar
        leftColumnChild.style.position = 'fixed';
        leftColumnChild.style.top = `${NAVBAR_HEIGHT}px`;
        leftColumnChild.style.width = `${oldWidth}px`;
        leftColumnChild.style.bottom = 'auto';
      } else {
        // Reset styles
        leftColumnChild.style.position = 'relative';
        leftColumnChild.style.width = '100%';
        leftColumnChild.style.top = '0';
        leftColumnChild.style.bottom = 'auto';
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [isDesktop]);

  return (
    <Container>
      <LeftColumn ref={leftColumnRef}>{leftColumnContent}</LeftColumn>
      <RightColumn ref={rightColumnRef}>{rightColumnContent}</RightColumn>
    </Container>
  );
};

export default TwoColumnScrollSync;

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;

  > div {
    width: 50%;

    @media (max-width: 1024px) {
      width: 100%;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftColumn = styled.div``;

const RightColumn = styled.div``;
